import dayjs from "dayjs";
import { IFSCategory, IFSProject, IFSProposal, IFSSubcategory } from "../../interfaces/IFSForecast.interfaces";

export const sumAllProjectsMonthlyTotal = (
    projects: IFSProject[],
    month: string
) => {
    return (
        projects.reduce(
            (projSum, project) =>
                projSum +
                project.proposals?.reduce(
                    (pSum, p) =>
                        pSum +
                        p.categories?.reduce(
                            (cSum, c) =>
                                cSum +
                                c.subcategories?.reduce(
                                    (sSum, s) =>
                                        sSum +
                                        (s.feeStages?.reduce((fSum, f) => {
                                            const value =
                                                f.forecasts?.find(
                                                    x => dayjs(x.monthDate).format("MMM-YYYY") === month
                                                )?.forecastValue ?? 0;
                                            return fSum + value;
                                        }, 0) ?? 0),
                                    0
                                ),
                            0
                        ),
                    0
                ),
            0
        ) ?? 0
    );
};

export const sumProjectMonthlyTotal = (
    project: IFSProject,
    month: string
) => {
    return (
        project.proposals?.reduce(
            (pSum, p) =>
                pSum +
                p.categories?.reduce(
                    (cSum, c) =>
                        cSum +
                        c.subcategories?.reduce(
                            (sSum, s) =>
                                sSum +
                                (s.feeStages?.reduce((fSum, f) => {
                                    const value =
                                        f.forecasts?.find(
                                            x => dayjs(x.monthDate).format("MMM-YYYY") === month
                                        )?.forecastValue ?? 0;
                                    return fSum + value;
                                }, 0) ?? 0),
                            0
                        ),
                    0
                ),
            0
        ) ?? 0
    );
};
export const sumProposalMonthlyTotal = (
    proposal: IFSProposal,
    month: string
) => {
    return (
        proposal.categories?.reduce(
            (cSum, c) =>
                cSum +
                c.subcategories?.reduce(
                    (sSum, s) =>
                        sSum +
                        (s.feeStages?.reduce((fSum, f) => {
                            const value =
                                f.forecasts?.find(
                                    x => dayjs(x.monthDate).format("MMM-YYYY") === month
                                )?.forecastValue ?? 0;
                            return fSum + value;
                        }, 0) ?? 0),
                    0
                ),
            0
        ) ?? 0
    );
};

export const sumCategoryMonthlyTotal = (
    category: IFSCategory,
    month: string
) => {
    return (
        category.subcategories?.reduce(
            (sSum, s) =>
                sSum +
                (s.feeStages?.reduce((fSum, f) => {
                    const value =
                        f.forecasts?.find(
                            x => dayjs(x.monthDate).format("MMM-YYYY") === month
                        )?.forecastValue ?? 0;
                    return fSum + value;
                }, 0) ?? 0),
            0
        ) ?? 0
    );
};

export const sumSubcategoryMonthlyTotal = (
    subcategory: IFSSubcategory,
    month: string
) => {
    return (
        subcategory.feeStages?.reduce((fSum, f) => {
            const value =
                f.forecasts?.find(
                    x => dayjs(x.monthDate).format("MMM-YYYY") === month
                )?.forecastValue ?? 0;
            return fSum + value;
        }, 0) ?? 0
    );
};